export class NotificationConfig {
  id?: number
  enabled: boolean
  eventClass: string
  typeId?: string
  templateKey: string
  attachmentConfigs: Set<NotificationAttachmentConfig>
  isSendOncePerDay: boolean
  isSendInCommunicationTimeWindow: boolean
  shouldStoreExternally: boolean
  created: Date
  productSubType?: string
  brand: string
  sendConditions: Map<NotificationSendConditionType, string>
}

export class NotificationAttachmentConfig {
  templateKey: string
  isEnabled: boolean
  clientDocumentType?: string
}

export class NotificationConfigRequest {
  typeId: string
  enabled: boolean
  templateKey: string
  attachmentConfigs?: Set<NotificationAttachmentConfig>
  sendConditions: Map<NotificationSendConditionType, string>
  isSendOncePerDay: boolean
  isSendInCommunicationTimeWindow: boolean
  shouldStoreExternally: boolean
  productSubType?: string
  brand: string
}

export interface SendConditionForm {
  conditionKey: string;
  conditionValue: string;
}


export class NotificationConfigFormData {
  typeId: string
  enabled: boolean
  templateKey: string
  attachmentConfigs?: string
  isSendOncePerDay: boolean
  isSendInCommunicationTimeWindow: boolean
  shouldStoreExternally: boolean
  productSubType?: string
  brand: string
  sendConditions: SendConditionForm[];

  constructor(notificationConfig: NotificationConfig, availableConditions: string[] = []) {
    this.typeId = notificationConfig.typeId
    this.templateKey = notificationConfig.templateKey
    this.attachmentConfigs = JSON.stringify(notificationConfig.attachmentConfigs)
    this.enabled = notificationConfig.enabled
    this.isSendOncePerDay = notificationConfig.isSendOncePerDay
    this.isSendInCommunicationTimeWindow = notificationConfig.isSendInCommunicationTimeWindow
    this.shouldStoreExternally = notificationConfig.shouldStoreExternally
    this.productSubType = notificationConfig.productSubType
    this.brand = notificationConfig.brand;
    this.sendConditions = availableConditions.map(conditionKey => ({
      conditionKey,
      conditionValue: notificationConfig.sendConditions?.[conditionKey] || ''
    }));
  }
}


export enum NotificationCommunicationType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  PUSH = 'PUSH',
  TTS = 'TTS',
}

export enum NotificationCommunicationTypeSuffix {
  EMAIL = '.email.body',
  SMS = '.sms',
  PUSH = '.push.body',
  TTS = '.tts',
}

const CommunicationTypeSuffixList: Record<NotificationCommunicationType, string[]> = {
  EMAIL: ['.email.subject', '.email.body'],
  SMS: ['.sms'],
  PUSH: ['.push.title', '.push.body', '.push.link', '.push.icon'],
  TTS: ['.tts']
}

export function getCommunicationTypeSuffixList(notificationCommunicationType: NotificationCommunicationType | null) {
  switch (notificationCommunicationType) {
    case NotificationCommunicationType.EMAIL:
    case NotificationCommunicationType.SMS:
    case NotificationCommunicationType.PUSH:
    case NotificationCommunicationType.TTS:
      return CommunicationTypeSuffixList[notificationCommunicationType];
    default:
      return [''];
  }
}

export enum NotificationSendConditionType {
  LOAN_AGREEMENT_TYPE_NOT_EQUALS = 'LOAN_AGREEMENT_TYPE_NOT_EQUALS',
  LOAN_STATUS_DETAIL_NOT_EQUALS =  'LOAN_STATUS_DETAIL_NOT_EQUALS',
  LOAN_ID_LESS_THAN = 'LOAN_ID_LESS_THAN',
  LOAN_ID_GREATER_THAN_OR_EQUAL_TO = 'LOAN_ID_GREATER_THAN_OR_EQUAL_TO',
}
